import {globalConfig} from '../../Config/config';
import {Queries} from '../GQLConstants';
import {gqlCall, GQLType} from '../utils';

/**
 * @param {object} variables {referenceId: string, pageSize: number, pageNo: number}
 * @description
 * referenceId is internal member reference
 */
const gqlGifting = async (variables) => {
  try {
    const data = await gqlCall(
      GQLType.QUERY,
      Queries.GET_GIFTING_INFO,
      variables,
      null,
      globalConfig._config.BFF.astBFF,
      false,
    );
    return data;
  } catch (error) {
    return {error};
  }
};
/**
 * @param {object} variables {GiftingOfferInput:object}
 * @description
 * Gifting offer input is user email address
 */
const gqlSetMemberGift: any = async (variables) => {
  try {
    const data = await gqlCall(
      GQLType.MUTATION,
      Queries.GIVE_GIFT,
      variables,
      null,
      globalConfig._config.BFF.astBFF,
      false,
    );
    return data;
  } catch (error) {
    return {error};
  }
};

export {gqlGifting, gqlSetMemberGift};
